/* eslint-disable react/jsx-key */
import React, { Component, Fragment } from "react";
import { Card, Icon, Tag, Row, Col, Avatar, Radio, Button, Spin } from "antd";
import F from "../../../Functions";
import WizardFooter from "./wizard-footer";
// import Print from "./print-liability";
import { Translate } from "react-translated";
import axios from "axios";
import PDF from "./images/new/pdf.svg";
import Home from "./images/new/homeowners.svg";
import SecondaryHome from "./images/new/homeowners.svg";
import MFGHome from "./images/new/mfg.svg";
import Rentals from "./images/new/mfg.svg";
import None from "./images/new/none.svg";
import Condominium from "./images/new/condominium.svg";
import Landlord from "./images/bfile-landlord.svg";
import Other from "./images/new/other.svg";
import VacantProperty from "./images/new/vacant-land.svg";
import Umbrella from "./images/bfile-umbrella.svg";
import Umbrellas from "./images/Umbrella.png";
// import Bike from "./images/bike.png";
import House from "./images/house.png";
import Car from "./images/car.png";
import Bfilelogo from "./images/new/bfile-logo.jpg";
import Auto from "./images/new/classic_car.svg";
import ClassicCar from "./images/new/classic_car.svg";
import RV from "./images/new/rv.svg";
import Boat from "./images/new/boat.svg";
import Motorcycle from "./images/new/motor_cycle.svg";
import Drone from "./images/new/drone.svg";
import GolfCart from "./images/new/golf_cart.svg";
import Watercraft from "./images/new/water_craft.svg";
import Snowmobile from "./images/new/snowmobile.svg";
import OffRoad from "./images/bfile-offroad.svg";
import LifeInsurance from "./images/life-insurance.svg";
// import bfileLogo from "./images/bfile-homepicture.png";
// import "./landingpage.css";
import Step7_1 from "./step7_1";
import BFileStatusSelection from "./bfile-status-selection";
import CreateBfileList from "../../../components/create-bfile-list";
import { WIZARD } from "../../../utils/Constants";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";

const RadioGroup = Radio.Group;
// const { TextArea } = Input;

const gridStyle = {
  width: "20%",
  textAlign: "center",
  marginRight: "10px",
  borderRadius: "10px"
};

const gridStyle2 = {
  width: "20%",
  textAlign: "center",
  margin: "10px",
  borderRadius: "10px"
};

const gridStyle3 = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
};

const gridStyle4 = {
  display: "flex",
  alignItems: "center"
  //   justifyContent: 'space-between'
};

class Step extends Component {
  constructor(props) {
    super(props);
    this.state = {
      minimum_liability_limits: null,
      minimum_liability_limits_ext: {},
      carrier: null,
      auto_underlying_limit: null,
      home_underlying_limit: null,
      user: {},
      user_invited_user: {}
    };
  }

  componentDidMount() {
    let minimum_liability_limits_ext = {};
    axios.get("/api/user").then((res) => {
      const u = res.data;
      if (u.minimum_liability_limits_ext) {
        minimum_liability_limits_ext = JSON.parse(
          u.minimum_liability_limits_ext
        );
      }
      this.setState({
        minimum_liability_limits: u.minimum_liability_limits,
        minimum_liability_limits_ext,
        user: u,
        user_invited_user:
          u.invited_user !== null &&
          u.invited_user.minimum_liability_limits_ext !== null &&
          JSON.parse(u.invited_user.minimum_liability_limits_ext)
      });
    });

    axios.get("/api/get_ea_carrier").then(({ data: { message } }) => {
      // F.log(message);
      if (message) {
        if (message.minimum_liability_limits_ext) minimum_liability_limits_ext = JSON.parse(
          message.minimum_liability_limits_ext
        )
        this.setState({
          carrier: message.carrier || {},
          auto_underlying_limit: message.auto_underlying_limit,
          home_underlying_limit: message.home_underlying_limit,
          minimum_liability_limits_ext
        });
      }


    });


    var { wizard } = this.props;

    if (this.props.isFromDirectUrl) {
      if (
        wizard.employed_anual_income === null ||
        wizard.employed_anual_income === ""
      ) {
        this.props.updateField("employed_anual_income", "$25,001-$50,000");
      }

      if (
        wizard.spouse_first_name &&
        (wizard.employed_anual_income_spouse === null ||
          wizard.employed_anual_income_spouse === "")
      ) {
        this.props.updateField("employed_anual_income_spouse", "$25,001-$50,000");
      }
      this.props.updateRadioBtnToggle();
    }



  }


  viewPdf() {
    const that = this;
    const { wizard } = this.props;
    const { location } = this.props.history;
    if (wizard && wizard.rac_calculator && wizard.rac_calculator !== '0' && wizard.id && (location.state && location.state.isFromDirectUrl && document.querySelector(".user-data"))) {
      var printData = document.querySelector(".user-data");
      printData.style.display = "block";
      printData.style.position = "absolute";
      printData.style.padding = "25px";

      // html2canvas(printData).then(function(canvas) {
      //   var ctx = canvas.getContext("2d");
      //   var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      //   var data = imageData.data;

      //   for (var i = 0; i < data.length; i += 4) {
      //     var grayscale =
      //       data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114;
      //     data[i] = grayscale;
      //     data[i + 1] = grayscale;
      //     data[i + 2] = grayscale;
      //   }

      //   ctx.putImageData(imageData, 0, 0);

      //   const base64Image = canvas.toDataURL("image/png");
      //   const doc = new jsPDF("p", "mm", "a4");
      //   const componentWidth = doc.internal.pageSize.getWidth();
      //   doc.addImage(base64Image, "PNG", 0, 0, componentWidth, 0);
      //   const pdfBase64 = doc.output("datauristring");

      //   if (pdfBase64) {
      //     const blob = that.dataURItoBlob(pdfBase64.split(",")[1])
      //     const url = URL.createObjectURL(blob);
      //     window.location.replace(url);
      //   }
      // });
    }
  }


  dataURItoBlob = (dataURI) => {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    } const blob = new Blob([int8Array], { type: 'application/pdf' });
    return blob;
  }//data should be your response data in base64 format


  strToNumber = (str) => {
    str = str.replace(/\$/g, "");
    str = str.replace(/,/g, "");
    return parseInt(str);
  };

  getMinLiability = (liability, value) => {
    const { minimum_liability_limits_ext } = this.state;
    if (liability in minimum_liability_limits_ext) {
      var minimum_recommended = minimum_liability_limits_ext[liability];

      var is_home = [
        "Home",
        "Secondary Home",
        "MFG Home",
        "Rentals",
        "Condominium",
        "Landlord",
        "Vacant Property"
      ];
      if (is_home.indexOf(liability) >= 0) {
        if (this.strToNumber(minimum_recommended) > this.strToNumber(value)) {
          return minimum_recommended;
        } else {
          return value;
        }
      } else {
        const recommended_limit_f = F.get_first_value(value.replace("/", "-"));
        const minimum_recommended_f = F.get_first_value(
          minimum_recommended.replace("/", "-")
        );
        if (minimum_recommended_f > recommended_limit_f) {
          return minimum_recommended;
        } else {
          return value;
        }
      }
    } else {
      return value;
    }
  };

  getUmbrellaMessage = () => {
    if (
      this.props.wizard.carrier !== null &&
      this.state.user.carrier &&
      this.props.wizard.carrier &&
      this.state.user.carrier !== "Farm Bureau"
    ) {
      return "Your recommended limit is $500,000/$1,000,000 on your auto and $500,000 on your home. However, we recommend a 1-million-dollar umbrella with our minimum required underlying limits of $250,000/$500,000 for the auto and $300,000 on your home. That will protect your assets and also give you broader coverage.";
    } else {
      return "";
    }
  };

  // getUmbrellaValue = (value) => {
  //     if ((this.props.wizard.carrier !== null && this.props.wizard.carrier === 'Farm Bureau') || (this.state.user.carrier && this.state.user.carrier  === 'Farm Bureau')) {

  //     }
  // }

  showHomeAndAutoLimit = (auto_list, home_list, umbrella_list, wizard) => {
    let home_auto = [];
    let auto = auto_list.shift();
    let home = home_list.shift();

    home_auto.push(auto, home);

    // F.log("Home Auto = > ", home_auto);

    return (
      <Card bordered={false}>
        {home_auto.map((ha) => {
          return ha.value ? (
            <Card.Grid style={gridStyle} hoverable={false}>
              <Card.Meta
                avatar={<Avatar src={ha.icon} size="large" />}
                title={ha.title}
                description={ha.value}
              />
            </Card.Grid>
          ) : null;
        })}
      </Card>
    );
  };
  suggestedInsurance = (wizard) => {
    let mortgage_balance =
      parseInt(F.get_second_value(wizard.home_mortgage)) +
      parseInt(F.get_second_value(wizard.secondary_home_mortgage));
    let children =
      typeof wizard.children === "number"
        ? parseInt(wizard.children) * 100000
        : 0;
    let annual_income =
      parseInt(F.get_second_value(wizard.employed_anual_income)) * 3;

    // F.log("home mortgage =>", wizard.home_mortgage);
    // F.log("home mortgage =>", wizard.childrem);
    // F.log("home mortgage =>", wizard.employed_annual_income);

    let totalInsurance = mortgage_balance + children + annual_income;
    // F.log("Total Insurance = > ", totalInsurance);

    totalInsurance = isNaN(totalInsurance) ? 0 : totalInsurance;

    return (
      <Card bordered={false}>
        <Card.Grid style={gridStyle} hoverable={false}>
          <Card.Meta
            style={gridStyle4}
            avatar={<Avatar src={LifeInsurance} size="large" />}
            title={F.dollar_format(totalInsurance)}
          />
          {/* {F.dollar_format(totalInsurance)} */}
        </Card.Grid>
      </Card>
    );
  };

  showPoliciesView = (policiesDataList) => {
    return policiesDataList.map((chunkList) => (
      <tr>
        {chunkList.map((i) => {
          switch (i.type) {
            case "Classic Car":
              return (
                <td className="user-td-seven">
                  <img src={ClassicCar} alt={i.type} />
                  <p className="yes">{i.type}</p>
                </td>
              );

            case "RV":
              return (
                <td className="user-td-seven">
                  <img src={RV} alt={i.type} />
                  <p className="yes">{i.type}</p>
                </td>
              );

            case "Boat":
              return (
                <td className="user-td-seven">
                  <img src={Boat} alt={i.type} />
                  <p className="yes">{i.type}</p>
                </td>
              );

            case "Motorcycle":
              return (
                <td className="user-td-seven">
                  <img src={Motorcycle} alt={i.type} />
                  <p className="yes">{i.type}</p>
                </td>
              );

            case "Drone":
              return (
                <td className="user-td-seven">
                  <img src={Drone} alt={i.type} />
                  <p className="yes">{i.type}</p>
                </td>
              );
            case "Watercraft":
              return (
                <td className="user-td-seven">
                  <img src={Watercraft} alt={i.type} />
                  <p className="yes">{i.type}</p>
                </td>
              );
            case "Golf Cart":
              return (
                <td className="user-td-seven">
                  <img src={GolfCart} alt={i.type} />
                  <p className="yes">{i.type}</p>
                </td>
              );
            case "Snowmobile":
              return (
                <td className="user-td-seven">
                  <img src={Snowmobile} alt={i.type} />
                  <p className="yes">{i.type}</p>
                </td>
              );
            case "Off Road":
              return (
                <td className="user-td-seven">
                  <img src={OffRoad} alt={i.type} />
                  <p className="yes">{i.type}</p>
                </td>
              );
            // case "Rent":
            //   return (
            //     <td className="user-td-seven">
            //       <img
            //         src={Rent}
            //
            //         alt={i.type}
            //       />
            //       <p className="yes">{i.type}</p>
            //     </td>
            //   );
            case "Secondary Home":
              return (
                <td className="user-td-seven">
                  <img src={SecondaryHome} alt={i.type} />
                  <p className="yes">{i.type}</p>
                </td>
              );
            case "MFG Home":
              return (
                <td className="user-td-seven">
                  <img src={MFGHome} alt={i.type} />
                  <p className="yes">{i.type}</p>
                </td>
              );
            case "Condominium":
              return (
                <td className="user-td-seven">
                  <img src={Condominium} alt={i.type} />
                  <p className="yes">{i.type}</p>
                </td>
              );

            case "Landlord":
              return (
                <td className="user-td-seven">
                  <img src={Landlord} alt={i.type} />
                  <p className="yes">{i.type}</p>
                </td>
              );
            case "Vacant Property":
              return (
                <td className="user-td-seven">
                  <img src={VacantProperty} alt={i.type} />
                  <p className="yes">{i.type}</p>
                </td>
              );
            case "Umbrella":
              return (
                <td className="user-td-seven">
                  <img src={Umbrella} alt={i.type} />
                  <p className="yes">{i.type}</p>
                </td>
              );
          }
        })}
      </tr>
    ));
  };

  renderRiskAssessmentCalculatorAndLiabilityAcknowledgementContainer = () => {
    const { wizard, updateField, handleBlur, updateRadioBtnToggle } = this.props;
    return (
      <React.Fragment>
        <Card className="insidecard stepcard step6">
          {/* <div className="right-align printForHide">
            <Button onClick={() => window.print()}>
              <Icon type="printer" /> <Translate text={`Print`} />
            </Button>
          </div> */}

          <h4 className="titleTextUnderline">
            <Translate text={`Intelligence Link`} /> <Icon
              style={{
                display: "inline-flex",
                alignItems: "center",
                color: "white",
                justifyContent: "center",
                backgroundColor: "#16D370",
                borderRadius: "50%",
                width: "15px",
                height: "15px"
              }}
              type="check" />
          </h4>
          <Card className="rac">
            {wizard.rac_auto > 0 && <Row className="rac_row">
              <Col span={12} style={{ textAlign: 'start' }}>Auto</Col>
              <Col span={12} style={{ textAlign: 'end' }}>{F.dollar_format(wizard.rac_auto)}</Col>
            </Row>}
            {wizard.rac_home > 0 && <Row className="rac_row">
              <Col span={12} style={{ textAlign: 'start' }}>Home</Col>
              <Col span={12} style={{ textAlign: 'end' }}>{F.dollar_format(wizard.rac_home)}</Col>
            </Row>}
            {wizard.rac_financial > 0 && <Row className="rac_row">
              <Col span={12} style={{ textAlign: 'start' }}>Retirement Assets</Col>
              <Col span={12} style={{ textAlign: 'end' }}>{F.dollar_format(wizard.rac_financial)}</Col>
            </Row>}
            {wizard.rac_financial_spouse > 0 && <Row className="rac_row">
              <Col span={12} style={{ textAlign: 'start' }}>Retirement Asset - Spouse/Partner</Col>
              <Col span={12} style={{ textAlign: 'end' }}>{F.dollar_format(wizard.rac_financial_spouse)}</Col>
            </Row>}
            {wizard.rac_income > 0 && <Row className="rac_row">
              <Col span={12} style={{ textAlign: 'start' }}>Income</Col>
              <Col span={12} style={{ textAlign: 'end' }}>{F.dollar_format(wizard.rac_income)}</Col>
            </Row>}
            {wizard.rac_income_spouse > 0 && <Row className="rac_row">
              <Col span={12} style={{ textAlign: 'start' }}>Spouse/Partner Income</Col>
              <Col span={12} style={{ textAlign: 'end' }}>{F.dollar_format(wizard.rac_income_spouse)}</Col>
            </Row>}
            {wizard.rac_customary_items > 0 && <Row className="rac_row">
              <Col span={12} style={{ textAlign: 'start' }}>Special Personal Prop</Col>
              <Col span={12} style={{ textAlign: 'end' }}>{F.dollar_format(wizard.rac_customary_items)}</Col>
            </Row>}
            {wizard.rac_calculator > 0 && <Row className="rac_row" style={{ color: "#219D5C" }}>
              <Col span={18} style={{ textAlign: 'start' }}>Based on the information provided, our Intelligence Link recommends you protect assets in this amount:</Col>
              <Col span={6} style={{ textAlign: 'end' }} className="racAmount">{F.dollar_format(wizard.rac_calculator)}</Col>
            </Row>}
          </Card>

          <div style={{ marginTop: 20 }} className="printForHide">
            <h4 className="titleTextUnderline">
              <Translate text={`Liability Acknowledgement`} />
            </h4>
            <h5>“Acknowledges that you have read and understand the results provided :”</h5>

            <RadioGroup className="radiogroup"
              value={wizard.acknowledge}
              onChange={(e) => {
                updateField("acknowledge", e.target.value);
                if (!this.props.isExternalBFile) {
                  updateRadioBtnToggle();
                }
              }
              }

            >
              <Radio value="1">
                <Translate text={`Yes`} />
              </Radio>
              <Radio value="0">
                <Translate text={`No`} />
              </Radio>
            </RadioGroup>
          </div>
        </Card>
      </React.Fragment>
    );
  };

  getSuggestedMinimumLifeInsuranceValue = () => {
    const { user_invited_user, minimum_liability_limits_ext } = this.state;

    const key = "Suggested Minimum Life Insurance";

    // min Liability From `invited_user` Instance
    const minLiabilityFromInvitedUserInstance = user_invited_user[key];

    // min Liability From main Instance
    const minLiabilityFromMainInstance = minimum_liability_limits_ext[key];
    if (
      minLiabilityFromInvitedUserInstance &&
      minLiabilityFromInvitedUserInstance !== ""
    ) {
      return minLiabilityFromInvitedUserInstance;
    } else if (
      minLiabilityFromMainInstance &&
      minLiabilityFromMainInstance !== ""
    ) {
      return minLiabilityFromMainInstance;
    }
    return "3x";
  };

  renderSuggestedMinimumLifeInsuranceContainer = () => {
    const { wizard } = this.props;

    const totalInsurance = F.lifeInsurance(
      wizard,
      this.state.minimum_liability_limits_ext
    );

    let lifeInsurance = [{
      title: "",
      icon: LifeInsurance,
      value: F.dollar_format(totalInsurance)
    }]



    return totalInsurance > 0 ? (
      <div style={{ margin: '10px 0px' }}>
        <span className="titleTextUnderline">Suggested Minimum Life Insurance </span>
        <br></br>
        <span style={{
          display: "inline-block",
          marginBottom: 20,
          fontWeight: 500,
          fontSize: 'calc(11px + (0.1vw + 0.11px))',
          color: '#164897'
        }} >
          {`(Primary mortgage balance + Secondary Mortgage balance) + ( number of kids x $100,000) + (Income x ` +
            this.getSuggestedMinimumLifeInsuranceValue() + `)`
          }</span>
        <CreateBfileList list_info={lifeInsurance} noValue={false} />
      </div>
    ) : null;
  };

  renderAdditionalPCOpportunities = (home_list, auto_list) => {
    const newHomeList = home_list.filter((s) => s.title !== "Home");
    const newAutoList = auto_list.filter((s) => s.title !== "Auto");

    let home_auto = [...newHomeList, ...newAutoList].filter((ha) => ha.title !== "Home")

    return home_auto.length > 0 ? (
      <div style={{ margin: '15px 0px' }}>
        <h4 className="titleTextUnderline" style={{ marginBottom: "20px" }}>Additional P&C Opportunities</h4>
        <CreateBfileList list_info={home_auto} noValue={true} />
      </div>
    ) : null;
  };

  renderAutoAndHomeLimitContainer = (auto_list, home_list) => {
    const { wizard } = this.props;

    let home_auto = [];
    let auto = auto_list.shift();
    let home = home_list.shift();

    home_auto.push(auto, home);

    // new code added to filter out list contains value
    const homeAutoListContainsValue = home_auto.filter((s) => s.value !== "");

    const showAutoAndHomeLimitContainer =
      (wizard.rac_calculator > 0 ||
        wizard.carrier !== "Farm Bureau" ||
        this.state.carrier !== "Farm Bureau") &&
      homeAutoListContainsValue.length > 0;

    return showAutoAndHomeLimitContainer ? (

      <React.Fragment>
        <div style={{ margin: '20px 0px 10px 0px' }}>
          <h4 className="titleTextUnderline" style={{ marginBottom: "20px" }}>Auto & Home Limit</h4>
          <CreateBfileList list_info={home_auto} noValue={false} />
        </div>
      </React.Fragment>
    ) : null;
  };

  renderUmberellaLimit = (umbrella_list) => {
    const { wizard } = this.props;
    return umbrella_list.length > 0 ? (
      <div style={{ margin: '10px 0px' }}>
        <h4 className="titleTextUnderline" style={{ marginBottom: "20px" }} >Recommended Umbrella Limit</h4>
        <CreateBfileList list_info={umbrella_list} noValue={false} />
      </div>
    ) : null;
  };


  personalInformation = () => {
    const { wizard } = this.props;
    return (
      <div style={{ margin: '10px 0px' }}>
        <h4 className="titleTextUnderline">Customer Information</h4>
        <Row gutter={[16, 16]} className="personalinfo">
          <Col xs={24} sm={12} md={7}>
            Name: <span>{wizard.first_name + " " + wizard.last_name}</span>
          </Col>
          <Col xs={24} sm={12} md={5}>
            Phone: <span>{F.phone_format(wizard.phone)}</span>
          </Col>
          <Col xs={24} sm={12} md={8}>
            Email: <span>{wizard.email}</span>
          </Col>
          {wizard.carrier !== WIZARD.CARRIER.COUNTRY_FINANCIAL && (
            <Col xs={24} sm={12} md={4}>
              DOB: <span>{wizard.dob_mm + "-" + wizard.dob_yyyy}</span>
            </Col>
          )}
        </Row>
      </div>

    )
  }

  render() {
    let that = this;
    const { wizard, updateField, handleBlur, updateRadioBtnToggle } = this.props;
    let umbrella_limit = wizard.umbrella_limit;
    const {
      minimum_liability_limits,
      minimum_liability_limits_ext,
      user_invited_user,
      user_invited_user_auto
    } = this.state;

    // F.log(
    //   "this.state",
    //   this.state.minimum_liability_limits_ext[
    //     "Suggested Minimum Life Insurance"
    //   ]
    // );
    let autoUnderlyingLimit;
    let homeUnderlyingLimit;
    // if (this.state.user.invited_user === null) {
    //   autoUnderlyingLimit = this.state.minimum_liability_limits_ext["Auto"];
    //   homeUnderlyingLimit = this.state.minimum_liability_limits_ext["Home"];
    // }
    // if (this.state.user.invited_user !== null) {
    //   autoUnderlyingLimit =
    //     this.state.user_invited_user && this.state.user_invited_user["Auto"]; // $25,000/$50,000
    //   homeUnderlyingLimit =
    //     this.state.user_invited_user && this.state.user_invited_user["Home"]; // $100,000
    // }


    //to set the minimum value for home and auto irrespect of usertype
    if (this.state.minimum_liability_limits_ext) {
      autoUnderlyingLimit = this.state.minimum_liability_limits_ext["Auto"];
      homeUnderlyingLimit = this.state.minimum_liability_limits_ext["Home"];
    }
    // const autoUnderlyingLimit = this.state.user.invited_user && this.state.user.invited_user === null ? this.state.minimum_liability_limits_ext["Auto"]:this.state.user_invited_user && this.state.user_invited_user["Auto"]; // $25,000/$50,000
    // const homeUnderlyingLimit = this.state.user.invited_user && this.state.user.invited_user === null ? this.state.minimum_liability_limits_ext["Home"]:this.state.user_invited_user && this.state.user_invited_user["Home"]; // $100,000

    let recommended_limit = "";
    let recommended_limit_2 = "";
    let umbrella_message = "";

    F.log("NOOR New Auto Underlying Limit ==>> " + autoUnderlyingLimit); // 100/300
    F.log("NOOR New Home Underlying Limit ==>>" + homeUnderlyingLimit); // 100,000

    F.log("AAAAA ------------------------------------------------- ");
    F.log("AAAAA Props Wizard Carrier ==>>" + this.props.wizard.carrier);
    F.log("AAAAA State Wizard Carrier ==>>" + this.state.carrier);
    F.log("AAAAA autoUnderlyingLimit ==>>" + autoUnderlyingLimit);
    F.log("AAAAA homeUnderlyingLimit ==>>" + homeUnderlyingLimit);

    if (
      (this.props.wizard.carrier !== null &&
        this.props.wizard.carrier === "Farm Bureau") ||
      (this.state.carrier === "Farm Bureau" &&
        autoUnderlyingLimit &&
        homeUnderlyingLimit)
    ) {
      F.log("NOOR 1");
      // F.log(
      //   "autoUnderlyingLimit",
      //   autoUnderlyingLimit,
      //   "homeUnderlyingLimit",
      //   homeUnderlyingLimit,
      //   "this.state.minimum_liability_limits_ext",
      //   JSON.stringify(this.state.minimum_liability_limits_ext)
      // );
      // F.log("wizard ==> 1");

      switch (autoUnderlyingLimit) {
        case "100/300":
          if (
            wizard.rac_calculator &&
            wizard.rac_calculator <= 249999 &&
            wizard.rac_calculator > 0
          )
            recommended_limit = "$100,000/$300,000";
          else if (
            wizard.rac_calculator &&
            wizard.rac_calculator > 249999 &&
            wizard.rac_calculator > 0
          )
            recommended_limit = "$500,000/$500,000";
          break;
        case "250/500":
          if (
            wizard.rac_calculator &&
            wizard.rac_calculator <= 249999 &&
            wizard.rac_calculator > 0
          )
            recommended_limit = "$250,000/$500,000";
          else if (
            wizard.rac_calculator &&
            wizard.rac_calculator > 249999 &&
            wizard.rac_calculator > 0
          )
            recommended_limit = "$500,000/$500,000";
          break;
        case "500/500":
          recommended_limit = "$500,000/$500,000";
          break;
        default:
          if (
            wizard.rac_calculator &&
            wizard.rac_calculator <= 99999 &&
            wizard.rac_calculator > 0
          )
            recommended_limit = "$100,000/$300,000";
          if (
            wizard.rac_calculator &&
            wizard.rac_calculator > 99999 &&
            wizard.rac_calculator <= 249999 &&
            wizard.rac_calculator > 0
          )
            recommended_limit = "$250,000/$500,000";
          if (
            wizard.rac_calculator &&
            wizard.rac_calculator > 249999 &&
            wizard.rac_calculator > 0
          )
            recommended_limit = "$500,000/$500,000";
          break;
      }
      F.log("wizard ==> recommended_limit ", recommended_limit); // $100,000/$300,000

      switch (homeUnderlyingLimit) {
        case "300,000":
          if (
            wizard.rac_calculator &&
            wizard.rac_calculator <= 249999 &&
            wizard.rac_calculator > 0
          )
            recommended_limit_2 = "$300,000";
          else if (wizard.rac_calculator && wizard.rac_calculator > 249999)
            recommended_limit_2 = "$500,000";
          break;
        case "500,000":
          if (wizard.rac_calculator && wizard.rac_calculator > 0)
            recommended_limit_2 = "$500,000";
          break;
        default:
          if (
            wizard.rac_calculator &&
            wizard.rac_calculator <= 99999 &&
            wizard.rac_calculator > 0
          )
            recommended_limit_2 = "$100,000";
          if (
            wizard.rac_calculator &&
            wizard.rac_calculator > 99999 &&
            wizard.rac_calculator <= 249999
          )
            recommended_limit_2 = "$300,000";
          if (wizard.rac_calculator && wizard.rac_calculator > 249999)
            recommended_limit_2 = "$500,000";
          break;
      }
      F.log("wizard ==> recommended_limit_2 ", recommended_limit_2); // $100,000
    }

    if (
      this.state.carrier !== null &&
      this.state.carrier !== "Farm Bureau" &&
      autoUnderlyingLimit &&
      homeUnderlyingLimit
    ) {
      F.log("NOOR 2");
      // if (wizard.rac_calculator && wizard.rac_calculator == 0) {
      //   recommended_limit = "$25,000/$50,000";
      // }
      if (wizard.rac_calculator && wizard.rac_calculator != 0 && wizard.rac_calculator < 25000) {
        recommended_limit = "$25,000/$50,000";
        recommended_limit_2 = F.getWizardHomeValue(wizard); //home
      }
      if (
        wizard.rac_calculator &&
        wizard.rac_calculator >= 25000 &&
        wizard.rac_calculator < 50000
      ) {
        recommended_limit_2 = F.getWizardHomeValue(wizard); //home
        recommended_limit = "$50,000/$100,000"; //auto
      }
      if (
        wizard.rac_calculator &&
        wizard.rac_calculator >= 50000 &&
        wizard.rac_calculator < 100000
      ) {
        recommended_limit_2 = F.getWizardHomeValue(wizard); //home
        recommended_limit = "$100,000/$300,000"; //auto
      }
      if (
        wizard.rac_calculator &&
        wizard.rac_calculator >= 100000 &&
        wizard.rac_calculator < 250000
      ) {
        recommended_limit_2 = wizard.home_toggle == "0" ? "" : "$300,000"; //home
        recommended_limit = "$250,000/$500,000"; //auto
      }
      if (
        wizard.rac_calculator &&
        wizard.rac_calculator >= 250000 &&
        wizard.rac_calculator < 500000
      ) {
        F.log("umbrella_limit => 1");
        recommended_limit_2 = wizard.home_toggle == "0" ? "" : "$500,000"; //home
        recommended_limit = "$500,000/$1,000,000"; //auto
        umbrella_limit = "$1,000,000";
      }
      if (
        wizard.rac_calculator &&
        wizard.rac_calculator >= 500000 &&
        wizard.rac_calculator < 600000
      ) {
        F.log("umbrella_limit => 2");
        recommended_limit_2 = wizard.home_toggle == "0" ? "" : "$300,000"; //home
        recommended_limit = "$250,000/$500,000"; //auto
        umbrella_limit = "$1,000,000";
      }
      if (
        wizard.rac_calculator &&
        wizard.rac_calculator > 600000 &&
        wizard.rac_calculator < 1300000
      ) {
        F.log("umbrella_limit => 3");
        recommended_limit_2 = wizard.home_toggle == "0" ? "" : "$300,000"; //home
        recommended_limit = "$250,000/$500,000"; //auto
        umbrella_limit = "$1,000,000";
      }
      if (
        wizard.rac_calculator &&
        wizard.rac_calculator >= 1300000 &&
        wizard.rac_calculator < 2300000
      ) {
        F.log("umbrella_limit => 4");
        recommended_limit_2 = wizard.home_toggle == "0" ? "" : "$300,000"; //home
        recommended_limit = "$250,000/$500,000"; //auto
        umbrella_limit = "$2,000,000";
      }
      if (
        wizard.rac_calculator &&
        wizard.rac_calculator >= 2300000 &&
        wizard.rac_calculator < 4000000
      ) {
        F.log("umbrella_limit => 5");
        recommended_limit_2 = wizard.home_toggle == "0" ? "" : "$300,000"; //home
        recommended_limit = "$250,000/$500,000"; //auto
        umbrella_limit = "$3,000,000";
      }
      if (
        wizard.rac_calculator &&
        wizard.rac_calculator >= 4000000 &&
        wizard.rac_calculator < 5000000
      ) {
        F.log("umbrella_limit => 6");
        recommended_limit_2 = wizard.home_toggle == "0" ? "" : "$300,000"; //home
        recommended_limit = "$250,000/$500,000"; //auto
        umbrella_limit = "$4,000,000";
      }
      if (wizard.rac_calculator && wizard.rac_calculator >= 5000000) {
        F.log("umbrella_limit => 7");
        recommended_limit_2 = wizard.home_toggle == "0" ? "" : "$300,000"; //home
        recommended_limit = "$250,000/$500,000"; //auto
        umbrella_limit = "$5,000,000";
      }

      // recommended_limit = "$100,000/$300,000"; //auto
      // recommended_limit_2 = "$100,002"; //home
    }

    // if (wizard.rac_calculator >= 500000 && wizard.rac_calculator <= 1249999) {
    //   recommended_limit =
    //     (this.props.wizard.carrier !== null &&
    //       this.props.wizard.carrier === "Farm Bureau") ||
    //     (this.state.user.carrier &&
    //       this.state.user.carrier === "Farm Bureau")
    //       ? "$500,000/$500,000"
    //       : "$250,000/$500,000";
    //   recommended_limit_2 =
    //     (this.props.wizard.carrier !== null &&
    //       this.props.wizard.carrier === "Farm Bureau") ||
    //     (this.state.user.carrier &&
    //       this.state.user.carrier === "Farm Bureau")
    //       ? "$500,000"
    //       : "$300,000";
    //   umbrella_limit = 1000000;
    // }
    // if (wizard.rac_calculator >= 1250000) {
    //   recommended_limit =
    //     (this.props.wizard.carrier !== null &&
    //       this.props.wizard.carrier === "Farm Bureau") ||
    //     (this.state.user.carrier &&
    //       this.state.user.carrier === "Farm Bureau")
    //       ? "$500,000/$500,000"
    //       : "$250,000/$500,000";
    //   recommended_limit_2 =
    //     (this.props.wizard.carrier !== null &&
    //       this.props.wizard.carrier === "Farm Bureau") ||
    //     (this.state.user.carrier &&
    //       this.state.user.carrier === "Farm Bureau")
    //       ? "$500,000"
    //       : "$300,000";
    //   umbrella_limit = 2000000;
    // }
    // F.log("wizard ==>", this.minimum_liability_limits, minimum_liability_limits);
    if (
      (minimum_liability_limits &&
        this.props.wizard.carrier !== null &&
        this.props.wizard.carrier !== "Farm Bureau") ||
      (this.state.user.carrier && this.state.user.carrier !== "Farm Bureau")
    ) {
      const recommended_limit_f = F.get_first_value(
        recommended_limit.replace("/", "-")
      ); // 250,000

      if (minimum_liability_limits === "$25,000/$50,000") {
        recommended_limit = "$25,000/$50,000";
        recommended_limit_2 = "$100,000";
      }

      if (minimum_liability_limits === "$50,000/$100,000") {
        recommended_limit = "$50,000/$100,000";
        recommended_limit_2 = "$100,000";
      }

      if (minimum_liability_limits === "$100,000/$300,000") {
        if (recommended_limit_f <= 100000) {
          recommended_limit = "$100,000/$300,000";
          recommended_limit_2 = "$100,000";
        }
      }

      if (minimum_liability_limits === "$250,000/$500,000") {
        if (recommended_limit_f <= 250000) {
          recommended_limit =
            (this.props.wizard.carrier !== null &&
              this.props.wizard.carrier === "Farm Bureau") ||
              (this.state.user.carrier &&
                this.state.user.carrier === "Farm Bureau")
              ? "$500,000/$500,000"
              : "$250,000/$500,000";
          recommended_limit_2 = "$300,000";
        }
      }

      if (minimum_liability_limits === "$500,000/$1,000,000") {
        recommended_limit = "$500,000/$1,000,000";
        recommended_limit_2 = "$500,000";
      }
    }

    if (wizard.rac_calculator <= 499999) {
      F.log("umbrella_limit => 8");
      umbrella_limit = "";
    }
    // if (wizard.rac_calculator >= 250000 && wizard.rac_calculator <= 499999) {
    //   F.log("umbrella_limit => 9");
    //   umbrella_limit = 1000000;
    //   umbrella_message = this.getUmbrellaMessage();
    // }
    if (wizard.rac_calculator >= 500000 && wizard.rac_calculator <= 1249999) {
      F.log("umbrella_limit => 9-10");
      umbrella_limit = 1000000;
      umbrella_message = this.getUmbrellaMessage();
    }
    if (wizard.rac_calculator >= 1250000 && wizard.rac_calculator <= 2249999) {
      F.log("umbrella_limit => 10");
      umbrella_limit = 2000000;
    }
    if (wizard.rac_calculator >= 2250000 && wizard.rac_calculator <= 3249999) {
      F.log("umbrella_limit => 11");
      umbrella_limit = 3000000;
    }
    if (wizard.rac_calculator >= 3250000 && wizard.rac_calculator <= 4249999) {
      F.log("umbrella_limit => 12");
      umbrella_limit = 4000000;
    }
    if (wizard.rac_calculator >= 4250000 && wizard.rac_calculator <= 5249999) {
      F.log("umbrella_limit => 13");
      umbrella_limit = 5000000;
    }
    if (wizard.rac_calculator >= 5250000 && wizard.rac_calculator <= 6249999) {
      F.log("umbrella_limit => 14");
      umbrella_limit = 6000000;
    }
    if (wizard.rac_calculator >= 6250000 && wizard.rac_calculator <= 7249999) {
      F.log("umbrella_limit => 15");
      umbrella_limit = 7000000;
    }
    if (wizard.rac_calculator >= 7250000 && wizard.rac_calculator <= 8249999) {
      F.log("umbrella_limit => 16");
      umbrella_limit = 8000000;
    }
    if (wizard.rac_calculator >= 8250000 && wizard.rac_calculator <= 9249999) {
      F.log("umbrella_limit => 17");
      umbrella_limit = 9000000;
    }
    if (wizard.rac_calculator >= 9250000) {
      F.log("umbrella_limit => 18");
      umbrella_limit = 10000000;
    }

    // new add condition
    if (Number(wizard.rac_calculator) < 25000) {
      umbrella_limit = "";
    }

    // recommended_limit = "1223333";
    // recommended_limit_2 = "1223333";

    F.log("NOOR -->> Auto Limit ==>>" + recommended_limit);
    F.log("NOOR -->> Home Limit ==>>" + recommended_limit_2);
    F.log("rac_calculator ==>>" + wizard.rac_calculator);

    // comment for now
    wizard.auto_policy_recommended_limit = recommended_limit; // "$25,000/$50,000"
    wizard.home_policy_recommended_limit_2 = recommended_limit_2; //"$100,000"

    let home_list = [
      {
        title: "Home",
        icon: Home,
        // value: this.getMinLiability("Home", recommended_limit_2),
        value: recommended_limit_2
      }
    ];

    let auto_list = [];
    let umbrella_list = [];

    if (wizard.home_toggle === "1") {
      if (home_list[0] && home_list[0].value === "$0") home_list.shift();
      home_list.unshift({
        title: "Home",
        icon: Home,
        // value: this.getMinLiability("Home", recommended_limit_2),
        value: recommended_limit_2
      });
    }

    let name = null;
    let icon = null;
    let value = null;

    if (wizard.secondary_home_type) {
      const secondary_home_type = JSON.parse(wizard.secondary_home_type);
      if (secondary_home_type) {
        for (let i = 0, len = secondary_home_type.length; i < len; i++) {
          name = secondary_home_type[i];
          icon = null;
          if (name === "Secondary Home") icon = SecondaryHome;
          if (name === "MFG Home") icon = MFGHome;
          if (name === "Rentals") icon = Rentals;
          if (name === "Condominium") icon = Condominium;
          if (name === "Landlord") icon = Landlord;
          if (name === "Vacant Property") icon = VacantProperty;
          if (name === "Others") icon = Other;
          home_list.push({
            title: name,
            icon: icon,
            value: this.getMinLiability(name, recommended_limit_2)
          });
        }
      }
    }

    // F.log("wizard ==> auto_list length - 1 ==> ", auto_list.length);
    auto_list.push({
      title: "Auto",
      icon: Auto,
      // value: this.getMinLiability("Auto", recommended_limit),
      value: recommended_limit
    });
    /* auto_list: [
              {
                "title":"Auto",
                "icon":"/static/media/bfile-classic_car.8f39d36a.svg",
                "value":"$100,000/$300,000"
              }
            ] */
    wizard.umbrella_limit = umbrella_limit;
    if (umbrella_limit !== "") {
      umbrella_list.push({
        title: "Umbrella",
        icon: Umbrella,
        value: umbrella_limit,
        message: umbrella_message
      });
    }

    if (wizard.secondary_vehicles) {
      const secondary_vehicles = JSON.parse(wizard.secondary_vehicles);
      if (secondary_vehicles) {
        for (let i = 0, len = secondary_vehicles.length; i < len; i++) {
          name = secondary_vehicles[i];
          icon = null;
          if (name === "Classic Car") {
            icon = ClassicCar;
            value = recommended_limit;
          }
          if (name === "RV") {
            icon = RV;
            value = recommended_limit;
          }
          if (name === "Boat") {
            icon = Boat;
            value = recommended_limit_2;
          }
          if (name === "Motorcycle") {
            icon = Motorcycle;
            value = recommended_limit;
          }
          if (name === "Drone") {
            icon = Drone;
            value = recommended_limit;
          }
          if (name === "Golf Cart") {
            icon = GolfCart;
            value = recommended_limit;
          }
          if (name === "Water Craft") {
            icon = Watercraft;
            value = recommended_limit_2;
          }
          if (name === "Snowmobile") {
            icon = Snowmobile;
            value = recommended_limit;
          }
          if (name === "ATV") {
            icon = OffRoad;
            value = recommended_limit;
          }
          if (name === "Other") {
            icon = Other;
            value = recommended_limit;
          }
          auto_list.push({
            title: name,
            icon: icon,
            value: this.getMinLiability(name, value)
          });
        }
      }
    }

    // F.log("PNC ITEMS => home_list => ", JSON.stringify(home_list));
    // F.log("PNC ITEMS => auto_list => ", JSON.stringify(auto_list));
    // F.log("PNC ITEMS => policies => ", JSON.stringify(wizard.policies));

    // method Returns => [[1, 2, 3, 4], [5, 6, 7, 8], [9, 10]]
    const policiesDataList = F.slicePoliciesIntoChunks(wizard.policies);
    F.log("policiesDataList => ", policiesDataList);

    F.log("umbrella_limit ==>> " + umbrella_limit);

    const umbrellaValue = F.dollar_format(umbrella_limit);
    const isUmbrellaHasValue =
      umbrellaValue != null && umbrellaValue != "" && umbrellaValue != "$NaN";

    // let agency_name = null;
    // let agency_address = "Not Available";
    // let agency_email = null;
    // let agency_phone = null;

    // if (wizard.agency_info && wizard.agency_info.name) {
    //   agency_name = wizard.agency_info.name;
    // }

    // if (wizard.agency_info && wizard.agency_info.address) {
    //   agency_address = wizard.agency_info.address;
    // }

    // if (wizard.agency_info && wizard.agency_info.address) {
    //   agency_address = wizard.agency_info.address;
    // }

    // if (wizard.agency_info && wizard.agency_info.email) {
    //   agency_email = wizard.agency_info.email;
    // }

    // if (wizard.agency_info && wizard.agency_info.phone) {
    //   agency_phone = F.phone_format(wizard.agency_info.phone);
    // }

    const {
      agency_name,
      agency_address,
      agency_email,
      agency_phone
    } = F.getAgencyData(wizard);


    const { location } = this.props.history;

    const showAutoAndHomeContent =
      wizard.auto_policy_recommended_limit ||
      wizard.home_policy_recommended_limit_2;


    if (wizard.rac_calculator && document.querySelector('.team-heading') && document.querySelector('.team-heading').textContent && location.state && location.state.isFromDirectUrl) {
      that.viewPdf()
    }
    return (
      <Spin tip="Loading Pdf" size={"large"} spinning={location.state && location.state.isFromDirectUrl || false}>
        {/* <div id="liabilityCard">
          <div className="show-print">
            <table className="user-data" cellPadding="0">
              <tr>
                <td>
                  <table
                    className="user-data-one hk_bg"
                    width="100%"
                    style={{
                      display: "flex"
                    }}
                  >
                    <tr
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%"
                      }}
                    >
                      <td className="user-data-td" vertical-align="middle">

                        {agency_name ? (
                          <h2
                            className="team-heading"
                            style={{ color: "black" }}
                          >{`${agency_name}`}</h2>
                        ) : null}
                        <p className="team-para" style={{ color: "grey" }}>{`Address: ${agency_address}`}</p>
                        {agency_email ? (
                          <p className="team-para" style={{ color: "grey" }}>{`Email: ${agency_email}`}</p>
                        ) : null}
                        {agency_phone ? (
                          <p className="team-para" style={{ color: "grey" }}>{`Phone: ${agency_phone}`}</p>
                        ) : null}
                      </td>
                      <td className="logo-wrap" vertical-align="middle">
                        <img src={Bfilelogo} />
                      </td>
                    </tr>
                  </table>

                  <table className="user-table-three">
                    <tr>
                      <td>
                        <table
                          className="pdf-basic-info-container"
                          style={{
                            display: "flex"
                          }}
                        >
                          <tr>
                            <td>
                              {wizard.first_name &&
                                wizard.first_name.trim().length > 0 && (
                                  <p>
                                    <span className="cal-wrap">
                                      Customer Name
                                    </span>{" "}
                                    {`${wizard.first_name} ${wizard.last_name}`}
                                  </p>
                                )}

                              <p className="cal-wrap">
                                Intelligence Link
                              </p>
                              <p className="cal-wrap-one">
                                Based on the information we just discussed our
                                Intelligence Link has determined that you
                                need to protect assets in the amount of:
                              </p>
                              <p className="cal-wrap-two">

                                {F.dollar_format(wizard.rac_calculator)}

                              </p>
                            </td>
                          </tr>
                        </table>

                        {showAutoAndHomeContent && (
                          <table
                            className={`auto-and-home-unit ${policiesDataList.length === 1
                              ? "auto-and-home-unit-for-fewer-items"
                              : ""
                              }`}
                          >
                            <tr>
                              <td>Auto & Home Unit</td>
                            </tr>
                          </table>
                        )}

                        {showAutoAndHomeContent && (
                          <table
                            className={`user-table-six ${policiesDataList.length === 1
                              ? "user-table-six-for-fewer-items"
                              : ""
                              }`}
                          >
                            <tr>
                              {wizard.auto_policy_recommended_limit && (
                                <td className="car-wrap">
                                  <img className="car-img" src={Car} alt="" />
                                  <p className="auto-para">Auto</p>
                                  <p className="num-para">
                                    {wizard.auto_policy_recommended_limit}
                                  </p>
                                </td>
                              )}
                              {wizard.home_policy_recommended_limit_2 && (
                                <td className="user-td-house">
                                  <img
                                    className="house-wrap"
                                    src={House}
                                    alt=""
                                  />
                                  <p className="auto-para">Home</p>
                                  <p className="num-para">
                                    {wizard.home_policy_recommended_limit_2}
                                  </p>
                                </td>
                              )}
                            </tr>
                          </table>
                        )}




                        {isUmbrellaHasValue && umbrella_limit !== "" && (
                          <table
                            className={`user-table-seven ${policiesDataList.length === 1
                              ? "user-table-seven-for-fewer-items"
                              : ""
                              }`}
                          >
                            <tr>
                              <td>Recommended Umbrella Limit</td>
                            </tr>
                          </table>
                        )}

                        {isUmbrellaHasValue && umbrella_limit !== "" && (
                          <table className="user-table-eight">
                            <tr>
                              <td>
                                <img
                                  className={
                                    policiesDataList.length > 1
                                      ? "um-img"
                                      : "um-img-for-fewer-items"
                                  }
                                  src={Umbrellas}
                                  alt=""
                                />
                                <p className="auto-para">Umbrella</p>
                                <p className="num-para">
                                  {umbrella_limit
                                    ? F.dollar_format(umbrella_limit)
                                    : ""}
                                </p>
                              </td>
                            </tr>
                          </table>
                        )}



                        {policiesDataList.length > 0 && (
                          <table
                            className={`user-table-seven ${policiesDataList.length === 1
                              ? "user-table-seven-for-fewer-items"
                              : ""
                              }`}
                          >
                            <tr>
                              <td>P & C ITEMS IN THE HOUSEHOLD</td>
                            </tr>
                          </table>
                        )}

                        {policiesDataList.length > 0 && (
                          <table
                            className={`user-tab-ten ${policiesDataList.length === 1
                              ? "user-tab-ten-for-fewer-items"
                              : ""
                              }`}
                            cellSpacing="0"
                          >
                            {this.showPoliciesView(policiesDataList)}
                          </table>
                        )}
                      </td>
                    </tr>
                  </table>



                  <table
                    className={`user-table-seven ${policiesDataList.length === 1
                      ? "user-table-seven-for-fewer-items"
                      : ""
                      }`}
                  >
                    <tr>
                      <td>Suggested Minimum Life Insurance</td>
                    </tr>
                  </table>
                  <table className="suggested-minimum-life-insurance">
                    <tr>
                      <td>
                        <img
                          className={
                            policiesDataList.length > 1
                              ? "um-img"
                              : "um-img-for-fewer-items"
                          }
                          src={LifeInsurance}
                          alt=""
                        />
                        <p className="auto-para">Insurance</p>
                        <p className="num-para">
                          {F.dollar_format(
                            F.lifeInsurance(
                              wizard,
                              this.state.minimum_liability_limits_ext,
                              this.state.user_invited_user &&
                              this.state.user_invited_user,
                              this.state.user.invited_user &&
                              this.state.user.invited_user
                            )
                          )}
                        </p>
                      </td>
                    </tr>
                  </table>

                  <table className="table-footer" cellSpacing="0">

                  </table>
                </td>
              </tr>
            </table>
          </div>

        </div> */}
        <div className="hide-print" style={{ marginTop: "-10px" }}>
          <Card className="insidecard stepcard"  >

            {
              (
                wizard.rac_calculator > 0)
                ?
                this.renderRiskAssessmentCalculatorAndLiabilityAcknowledgementContainer()
                : null
            }

            {
              (wizard.coverage === true) && (
                <React.Fragment>
                  {this.renderAutoAndHomeLimitContainer(auto_list, home_list)}
                  {this.renderUmberellaLimit(umbrella_list)}
                  {this.renderAdditionalPCOpportunities(home_list, auto_list)}
                  {this.renderSuggestedMinimumLifeInsuranceContainer()}
                </React.Fragment>
              )
            }

            {/* {this.renderAutoAndHomeLimitContainer(auto_list, home_list)}
              {this.renderUmberellaLimit(umbrella_list)}
              {this.renderSuggestedMinimumLifeInsuranceContainer()}
              {this.renderAdditionalPCOpportunities(home_list, auto_list)} */}
            {this.personalInformation()}


            {/* <h5 onClick={() => window.print()} style={{ textAlign: 'center', color: '#FF5C1C', marginTop: 20, cursor: 'pointer', fontSize:"14px" }}>Download PDF <img src={PDF} width={8} /></h5> */}

            {/* <WizardFooter {...this.props} /> */}
          </Card>

          <div className='stepFooter position-sticky' style={{
            height: 100, display: "flex", flexDirection: "column",
            justifyContent: "center"
          }}>
            {/* <Button shape="round" onClick={() => window.print()} style={{ alignSelf: "center", width: "fit-content", textAlign: 'center', color: '#FF5C1C', cursor: 'pointer', fontSize: "14px" }}>Download PDF  <img src={PDF} width={8} /></Button> */}
            <WizardFooter
              agency_owner_details={this.props.agency_owner_details}
              minimum_liability_limits_ext={this.state.minimum_liability_limits_ext}
              carrier={this.state.carrier}
              {...this.props} />
          </div>
        </div>
      </Spin >
    );
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/step6_updated.js